(function() {
	'use strict';
	angular.module('pharmaPortalApp').factory('CampaignProduct', CampaignProduct);

	CampaignProduct.$inject = [ '$resource' ];

	function CampaignProduct($resource) {
		var resourceUrl = 'api/campaign-products/:id';

		return $resource(resourceUrl, {}, {
			'query' : {
				method : 'GET',
				isArray : true
			},
			'get' : {
				method : 'GET',
				transformResponse : function(data) {
					if (data) {
						data = angular.fromJson(data);
					}
					return data;
				}
			},
			'update' : {
				method : 'PUT'
			}
		});
	}
})();
